var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.RedEnvelopeRainRuleConfig, {
        attrs: {
          "red-rule-flags": _vm.redRuleFlags,
          "red-rule-values": _vm.redRuleValues,
        },
      }),
      _c(_setup.RedEnvelopeRainTiersConfig, {
        attrs: { "red-tiers": _vm.localForm.redTiers },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }